module.exports = __webpack_public_path__ + "static/4-49e20faf2fd5ff544d50bdc821657bd9.jpg";